import { render, staticRenderFns } from "./gruposComerciales.vue?vue&type=template&id=5168709d"
import script from "./gruposComerciales.vue?vue&type=script&lang=js"
export * from "./gruposComerciales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports